import { render, staticRenderFns } from "./ProductionTests.vue?vue&type=template&id=7d4346b6&scoped=true"
import script from "./ProductionTests.vue?vue&type=script&lang=js"
export * from "./ProductionTests.vue?vue&type=script&lang=js"
import style0 from "./ProductionTests.vue?vue&type=style&index=0&id=7d4346b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4346b6",
  null
  
)

export default component.exports